import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { hideActivePopup } from 'Store/Overlay/Overlay.action';
import { PopupCartType } from 'Type/Cart.type';
import { scrollToTop } from 'Util/Browser';

import CartPopup from './CartPopup.component';
import { CART_POPUP_ID } from './CartPopup.config';

/** @namespace PeggysagePwa/Component/CartPopup/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    payload: state.PopupReducer.popupPayload[CART_POPUP_ID] || {},
    currencyCode: state.ConfigReducer.default_display_currency_code
});

/** @namespace PeggysagePwa/Component/CartPopup/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    hideActivePopup: () => dispatch(hideActivePopup())
});

/** @namespace PeggysagePwa/Component/CartPopup/Container */
export class CartPopupContainer extends PureComponent {
    static propTypes = {
        payload: PropTypes.shape({
            cart: PopupCartType,
            products: PropTypes.arrayOf(PropTypes.shape({
                sku: PropTypes.string,
                quantity: PropTypes.number
            }))
        }),
        currencyCode: PropTypes.string,
        hideActivePopup: PropTypes.func.isRequired
    };

    static defaultProps = {
        payload: {
            cart: null,
            product: []
        },
        currencyCode: null
    };

    state = {
        addedProducts: []
    };

    containerFunctions = {
        onViewCartButtonClick: this.onViewCartButtonClick.bind(this)
    };

    componentDidUpdate(prevProps) {
        const { payload: { cart } } = this.props;
        const { payload: { cart: prevCart } } = prevProps;

        if (cart !== prevCart) {
            this.setAddedProducts();
        }
    }

    componentWillUnmount() {
        if (this.observer) {
            if (this.observer.unobserve && this.node) {
                this.observer.unobserve(this.node);
            }

            if (this.observer.disconnect) {
                this.observer.disconnect();
            }

            this.observer = null;
        }
    }

    containerProps() {
        const { payload, currencyCode } = this.props;
        const { addedProducts } = this.state;

        return {
            payload,
            currencyCode,
            addedProducts
        };
    }

    setAddedProducts() {
        const {
            payload: {
                cart: {
                    items: cartItems
                } = {},
                products
            }
        } = this.props;

        if (!products || !cartItems) {
            return;
        }

        const addedProducts = products.map((product) => {
            const cartItem = cartItems.find((item) => item.product.sku === product.sku);
            return {
                product: cartItem?.product,
                quantity: product.quantity
            };
        });

        this.setState({ addedProducts });
    }

    onViewCartButtonClick() {
        const { hideActivePopup } = this.props;

        hideActivePopup();

        // eslint-disable-next-line no-magic-numbers
        setTimeout(scrollToTop, 100);
    }

    render() {
        return (
            <CartPopup
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CartPopupContainer);
